import { NewEdgeDataRef } from "@uikit/model/NewEdgeDataRef";
import { DataRefUtil } from "@uikit/util/DataRefUtil";
import { NewLineDataRef } from "./NewLineDataRef";
import { GroupDataRef } from "./GroupDataRef";
import { NodeDataRef } from "./NodeDataRef";
import { CreatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { EdgeDataRef } from "./EdgeDataRef";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { Node } from "reactflow";

/**
 * 用来管理原来 HomeUsePlugin 以下几个 ref 值
 *
 * - nodeDataRef
 * - edgeDataRef
 * - groupDataRef
 * - newEdgeDataRef
 * - newLineDataRef
 *
 */
export class CanvasDataRef {
  newEdgeDataRef: NewEdgeDataRef;
  newLineDataRef: NewLineDataRef;
  groupDataRef: GroupDataRef;
  nodeDataRef: NodeDataRef;
  edgeDataRef: EdgeDataRef;

  constructor(public creatorRefStore: CreatorRefStore, public creatorNodesStore: CreatorNodesStore) {
    this.newEdgeDataRef = new NewEdgeDataRef();
    this.newLineDataRef = new NewLineDataRef();
    this.groupDataRef = new GroupDataRef();
    this.nodeDataRef = new NodeDataRef();
    this.edgeDataRef = new EdgeDataRef();

    // !!!上面几个 class 建议不要通过构造器传递，为了防止上面数据在被 json 序列化的时候不会出现其他数据
    this.edgeDataRef.state.nodes = {
      get current(): Node<any>[] {
        return creatorNodesStore.getNodes();
      },
    };
    this.edgeDataRef.state.nodeIndexRef = creatorRefStore.nodeIndexRef;
    // 考虑到fot或其他以外地方可能还在使用该数据，暂时没删，但是fot应不在使用
    this.nodeDataRef.state.nodeIndexRef = creatorRefStore.nodeIndexRef;
    this.nodeDataRef.state.edgeIndexRef = creatorRefStore.edgeIndexRef;
  }

  getSimpleNodeV3 = (node: any): any => {
    return DataRefUtil.getSimpleNodeV3(node, this.newEdgeDataRef);
  };

  /**
   * 原来该方法用于返回除 functions 类型的 newEdgeDataRef，也就是不会用到 functions
   * 可暂时直接用 canvasNewEdgeData.state 替换，当 newEdgeDataRef 被移除，则可直接安全使用 newEdgeDataRef
   *
   * 参考原来 HomeUsePluginUtil.getSimpleNodeDataV3, 现移动到 DataRefUtil
   *
   * @param edge
   * @returns
   */
  getSimpleNodeDataV3 = (edge: any): Record<string, any> => {
    return DataRefUtil.getSimpleNodeDataV3(edge, this.newEdgeDataRef);
  };

  getSimpleEdgeV3(edge: any): any {
    return DataRefUtil.getSimpleEdgeV3(edge, this.newLineDataRef);
  }

  // getSimpleEdgeDataV3 = (edge: any): Record<string, any> => {
  //   return DataRefUtil.getSimpleEdgeDataV3(edge, this.newEdgeDataRef);
  // };
}
